import React from 'react'
import ReactDOM from 'react-dom/client'
import moment from 'moment'

import Root from './Root'
import reportWebVitals from './reportWebVitals'

moment.locale('en', {
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: 's',
    ss: '%ss',
    m: 'a m',
    mm: '%dm',
    h: 'an h',
    hh: '%dh',
    d: 'a d',
    dd: '%dd',
    M: 'a month',
    MM: '%dM',
    y: 'a year',
    yy: '%dY'
  }
})

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<Root />)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
